import { RefObject, useEffect, useLayoutEffect, useRef } from 'react';

let animationStartTime: number | null = null;
let visibleSkeletonsCount = 0;

const findAnimationByName = (element: HTMLDivElement, animationName: string): Animation | undefined => {
    if (!element.getAnimations) {
        return undefined;
    }
    const animations = element.getAnimations() as CSSAnimation[];
    return animations.find((animation) => animation.animationName.includes(animationName));
};

// хук для синхронизации анимации между разными инстансами скелетона
export const useSkeletonAnimationSync = (loading: boolean): RefObject<HTMLDivElement> => {
    const ref = useRef<HTMLDivElement>(null);
    const prevVisibleRef = useRef(loading);

    useLayoutEffect(() => {
        const prevVisible = prevVisibleRef.current;
        prevVisibleRef.current = loading;

        // поверяем что мы действительно скрыли ранее видимый скелетон, а не произошел маунт невидимого скелетона
        if (prevVisible && !loading) {
            visibleSkeletonsCount -= 1;
            return;
        }

        if (!ref.current) {
            return;
        }

        const animation = findAnimationByName(ref.current, 'skeleton');
        if (!animation) {
            return;
        }

        animationStartTime =
            visibleSkeletonsCount === 0 ? (document.timeline.currentTime as number) : animationStartTime;
        visibleSkeletonsCount += 1;
        animation.startTime = animationStartTime;
        animation.play();
    }, [loading]);

    useEffect(
        () => () => {
            visibleSkeletonsCount -= prevVisibleRef.current ? 1 : 0;
        },
        []
    );

    return ref;
};
